module.exports = __webpack_public_path__ + "static/media/81.868a00eb.wav";